import { useEffect } from "react";
import { useLogout } from "../../../../hooks/useLogout";

function Unauthorized() {
    const logout = useLogout();

    useEffect(() => {
        logout();
    }, [logout]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            Unauthorized
        </div>
    );
}

export default Unauthorized;